const keyWords = [
  {
    label: '王之陨落',
    rules: 'KF,kf,王陨,陨落'
  },
  {
    label: '双桅船',
    rules: '船'
  },
  {
    label: '门徒誓约',
    rules: '门徒'
  },
  {
    label: '深石地窖',
    rules: '地窖'
  },
  {
    label: '玻璃宝库',
    rules: '宝库,拱顶,vog'
  },
  {
    label: '最后遗愿',
    rules: '遗愿,意愿,一愿,瑞文'
  },
  {
    label: '救赎花园',
    rules: '花园'
  },
  {
    label: '二象性',
    rules: '新地牢,二象性'
  },
  {
    label: '贪婪之握',
    rules: '贪婪'
  },
  {
    label: '预言',
    rules: '预言'
  },
  {
    label: '异端深渊',
    rules: '深坑,月球地牢,深渊'
  },
  {
    label: '破碎王座',
    rules: '破碎,王座'
  },
  {
    label: '宗师',
    rules: '宗师'
  },
  {
    label: '日落',
    rules: '日落'
  },
  {
    label: '泉源',
    rules: '泉源'
  },
  {
    label: '永恒',
    rules: '永恒'
  },
  {
    label: '暗屋',
    rules: '暗屋'
  },
  {
    label: '巅峰',
    rules: '巅峰'
  }
]

export default keyWords
